import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[440px]">
        <div className="relative bg-background-100 overflow-hidden min-h-[300px] md:min-h-[440px]">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20scene%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20tablet%20showing%20webtoon%2C%20cup%20of%20coffee%2C%20soft%20afternoon%20light%2C%20minimalist%20interior%2C%20relaxing%20atmosphere%2C%20warm%20cream%20and%20beige%20tones%2C%20clean%20aesthetic&width=800&height=440&seq=cta-reading-scene&orientation=landscape"
            alt="舒适阅读韩漫场景"
            className="w-full h-full object-cover"
          />
          <div className="absolute top-6 left-6">
            <span className="text-xs font-medium text-background-50 bg-foreground-900/60 px-3 py-1 rounded-full">
              随时随地
            </span>
          </div>
          <div className="absolute bottom-6 left-6">
            <span className="font-heading text-4xl md:text-5xl font-black text-background-50 leading-tight block">
              沉浸
            </span>
            <span className="font-heading text-4xl md:text-5xl font-black text-background-50 leading-tight block">
              阅读
            </span>
            <span className="font-heading text-4xl md:text-5xl font-black text-background-50 leading-tight block">
              体验
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center text-center px-6 md:px-16 py-14 bg-background-50">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-900 leading-tight">
            开启你的
            <br />
            韩漫之旅
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-sm">
            无遮挡下拉式阅读，流畅舒适不打断。
            <br />
            每天更新最新韩漫，永远有好故事等着你。
          </p>
          <div className="mt-8">
            <Link
              to="/category/all"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              立即免费阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}